import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import {Message} from "element-ui";
import {getWeb3Example} from "@/utils/web3Contract";

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        name: 'layout',
        component: () => import('@/layout/index.vue'),
        redirect: '/index',
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('@/views/index/index.vue')
            },
            {
                path: 'sai',
                name: 'sai',
                component: () => import('@/views/sai/index.vue')
            },
            {
                path: 'CTC',
                name: 'CTC',
                component: () => import('@/views/CTC/index.vue')
            },
            {
                path: 'shop',
                name: 'shop',
                component: () => import('@/views/shop/index.vue')
            },
            {
                path: 'my',
                name: 'my',
                component: () => import('@/views/my/index.vue')
            },
        ]
    },
    {
        path: "/rule",
        name: "rule",
        meta: {
            title: '平台规则'
        },
        component: () => import('@/views/rule.vue')
    },
    {
        path: "/shell",
        name: "shell",
        meta: {
            title: '出售'
        },
        component: () => import('@/views/CTC/sell.vue')
    },
    {
        path: "/myBuyNav",
        name: "myBuyNav",
        meta: {
            title: '我的买入列表'
        },
        component: () => import('@/views/CTC/myBuyNav.vue')
    },
    // {
    //     path: "/myBuyList",
    //     name: "myBuyList",
    //     meta: {
    //         title: '我的买入列表'
    //     },
    //     component: () => import('@/views/CTC/myBuyList.vue')
    // },
    // {
    //     path: "/myBuyListInSell",
    //     name: "myBuyListInSell",
    //     meta: {
    //         title: '我的买入列表卖出内页'
    //     },
    //     component: () => import('@/views/CTC/myBuyListInSell.vue')
    // },
    {
        path: "/mySellList",
        name: "mySellList",
        meta: {
            title: '我的卖出列表'
        },
        component: () => import('@/views/CTC/mySellList.vue')
    },


    {
        path: "/team",
        name: 'team',
        meta: {
            title: '团队，直推，荐点'
        },
        component: () => import('@/views/my/team/index.vue')
    },
    {
        path: "/withdrawalApplication",
        name: 'withdrawalApplication',
        meta: {
            title: '提现申请'
        },
        component: () => import('@/views/my/withdrawalApplication/index.vue')
    },
	{
	    path: "/pledge",
	    name: 'pledge',
	    meta: {
	        title: '质押'
	    },
	    component: () => import('@/views/my/pledge/index.vue')
	},
    {
        path: "/myPledge",
        name: 'myPledge',
        meta: {
            title: '我的质押'
        },
        component: () => import('@/views/my/myPledge/index.vue')
    },
	{
	    path: "/myTeam",
	    name: 'myTeam',
	    meta: {
	        title: '我的团队'
	    },
	    component: () => import('@/views/my/myTeam/index.vue')
	},
	{
	    path: "/chariotDetail",
	    name: 'chariotDetail',
	    meta: {
	        title: '战车详情'
	    },
	    component: () => import('@/views/index/chariotDetail.vue')
	},
	{
	    path: "/interestRelease",
	    name: 'interestRelease',
	    meta: {
	        title: '利息释放记录'
	    },
	    component: () => import('@/views/my/record/interestRelease.vue')
	},
    {
        path: "/invite",
        name: 'invite',
        meta: {
            title: '邀请码'
        },
        component: () => import('@/views/invite.vue')
    },
    {
        path: "/revenueRecord",
        name: 'revenueRecord',
        meta: {
            title: '收益记录'
        },
        component: () => import('@/views/my/record/revenueRecord.vue')
    },
    {
        path: "/floatingRecord",
        name: 'floatingRecord',
        meta: {
            title: '流动记录'
        },
        component: () => import('@/views/my/record/floatingRecord.vue')
    },
    {
        path: "/pointsRecord",
        name: 'pointsRecord',
        meta: {
            title: '积分记录'
        },
        component: () => import('@/views/my/record/pointsRecord.vue')
    },
    {
        path: "/tradeTo",
        name: 'tradeTo',
        meta: {

            title: '转赠USDE'
        },
        component: () => import('@/views/my/tradeTo/tradeTo.vue')
    },
    {
        path: "/jsqr",
        name: 'jsqr',
        meta: {
            title: '转赠USDE'
        },
        component: () => import('@/views/my/tradeTo/jsqr.vue')
    },
    {
        path: "/changePassword",
        name: 'changePassword',
        meta: {
            title: '修改密码'
        },
        component: () => import('@/views/my/tradeTo/changePassword.vue')
    },
    {
        path: "/Notice",
        name: 'Notice',
        meta: {
            title: '公告'
        },
        component: () => import('@/views/Notice.vue')
    },
    {
        path: "/USDERecharge",
        name: 'USDERecharge',
        meta: {
            title: 'USDE充值'
        },
        component: () => import('@/views/my/usdeRecharge.vue')
    },
	{
	    path: "/swapGhs",
	    name: 'swapGhs',
	    meta: {
	        title: 'GHS闪兑'
	    },
	    component: () => import('@/views/my/swapGhs.vue')
	},
    {
        path: "/withdrawUsdeWaiting",
        name: 'withdrawUsdeWaiting',
        meta: {
            title: '提现申请列表'
        },
        component: () => import('@/views/my/withdrawalApplication/withdrawUsdeWaiting.vue')
    },
    {
        path: "/withdrawList",
        name: 'withdrawList',
        meta: {
            title: '质押提现列表'
        },
        component: () => import('@/views/my/withdrawalApplication/withdrawList.vue')
    },
    {
        path: "/withdrawListCheck",
        name: 'withdrawListCheck',
        meta: {
            title: '查询质押提现审核列表'
        },
        component: () => import('@/views/my/withdrawalApplication/withdrawListCheck.vue')
    },

    {
        path: "/amountAdd",
        name: 'amountAdd',
        meta: {
            title: '新增涡轮额度记录'
        },
        component: () => import('@/views/my/withdrawalApplication/amountAdd.vue')
    },

    {
        path: "/incomeRecord",
        name: 'incomeRecord',
        meta: {
            title: '质押收益记录'
        },
        component: () => import('@/views/my/record/incomeRecord.vue')
    },


    // ---------------------------报销系统---------------------


    {
        path: "/reimbursementPortal",
        name: 'reimbursementPortal',
        meta: {
            title: '申请列表'
        },
        component: () => import('@/views/reimbursementPortal/index.vue')
    },

    {
        path: "/supInformation",
        name: 'supInformation',
        meta: {
            title: '补充信息'
        },
        component: () => import('@/views/reimbursementPortal/supInformation.vue')
    },
    {
        path: "/angelRule",
        name: 'angelRule',
        meta: {
            title: '天使保障规则'
        },
        component: () => import('@/views/shop/angelRule.vue')
    },


    // ---------------------------商城---------------------
    {
        path: "/cityList",
        name: 'cityList',
        meta: {
            title: '城市'
        },
        component: () => import('@/views/shop/cityList.vue')
    },
    {
        path: "/kfcShopList",
        name: 'kfcShopList',
        meta: {
            title: '肯德基商铺列表'
        },
        component: () => import('@/views/shop/kfc/shopList.vue')
    },
    {
        path: "/kfcShopInfoList",
        name: 'kfcShopInfoList',
        meta: {
            title: '肯德基商品列表'
        },
        component: () => import('@/views/shop/kfc/shopInfoList.vue')
    },
    {
        path: "/mdlShopList",
        name: 'mdlShopList',
        meta: {
            title: '麦当劳商铺列表'
        },
        component: () => import('@/views/shop/mdl/shopList.vue')
    },
    {
        path: "/mdlShopInfoList",
        name: 'mdlShopInfoList',
        meta: {
            title: '麦当劳商品列表'
        },
        component: () => import('@/views/shop/mdl/shopInfoList.vue')
    },
    {
        path: "/xbkShopList",
        name: 'xbkShopList',
        meta: {
            title: '星巴克商铺列表'
        },
        component: () => import('@/views/shop/xbk/shopList.vue')
    },
    {
        path: "/xbkShopInfoList",
        name: 'xbkShopInfoList',
        meta: {
            title: 'xbk商品列表'
        },
        component: () => import('@/views/shop/xbk/shopInfoList.vue')
    },
    {
        path: "/shopOrderList",
        name: 'shopOrderList',
        meta: {
            title: '商品订单列表'
        },
        component: () => import('@/views/shop/order.vue')
    },


]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {

    return routerPush.call(this, location).catch(err => err)

}
// replace
VueRouter.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
const whiteList = ['sellOut', 'buy', 'layout', 'CTC', 'jsqr', 'invite'];
const adminList = ['0xd7de2914818ce9a27a59491595289bfe7a54a1bb']

router.beforeEach(async (to, from, next) => {
    // console.log('进入了首位')
    // return next()

    if (store.state.userStatus === 'success') {
        //判断是否是管理员
        let web3Vue = await getWeb3Example()
        const accounts = await web3Vue.eth.getAccounts();
        let name = accounts[0].toLowerCase();

        // console.log(adminList.some(ele => ele == name), name)
        if (adminList.some(ele => ele == name)) {
            // console.log('进入', to, from)
            return next()
        }


        let info = await store.dispatch('getUserInfoVue', false)


        // console.log('我走到了判断邀请码', info)

        // 判断是否有邀请码
        if (info.address1 == null || info.address1 === "") {
            // if (store.state.userInfo.address1 == null || store.state.userInfo.address1 ===   "") {
            // console.log('重定向');

            // 如果是从 jsqr 页面返回 invite，直接允许导航
            if (from.name === 'invite' && to.name === 'jsqr') {
                return next();
            }

            if (to.name !== 'invite') {
                return next({name: 'invite'});
            } else {
                return next();
            }
        } else {
            return next();
        }
    } else {
        if (whiteList.includes(to.name)) {
            return next();
        } else {
            store.dispatch('getUserStatusMethod').then(res => {
                if (res === 'success') {
                    return next();
                } else {
                    Message({
                        type: 'error',
                        customClass: 'customClass',
                        message: '请解决异常订单'
                    });
                    return next({name: 'CTC'});
                }
            })


        }
    }
});
// const whiteList = ['sellOut', 'buy', 'layout', 'CTC', 'jsqr', 'invite']
// router.beforeEach(async (to, form, next) => {
//     // console.log('全局路由1', to)
//     // console.log('全局路由1', store.state.userStatus)
//
//
//     if (store.state.userStatus == 'success') {
//
//         return next()
//
//
//     } else {
//
//         if (whiteList.some((e) => e == to.name)) {
//
//             return next()
//         } else {
//             store.dispatch('getUserStatusMethod').then(res => {
//                 if (res == 'success') {
//                     return next()
//
//                 } else {
//                     Message({
//                         type: 'error',
//                         customClass: 'customClass',
//                         message: '请解决异常订单'
//                     })
//
//
//                     return next({name: 'CTC'})
//                 }
//
//
//             })
//         }
//
//     }
// })

export default router
